import { Stack, TableCell, TableHead, TableRow } from "@mui/material";
import { ReactComponent as IconGenericDocIcon } from "assets/images/icons/generic-doc-icon.svg";
import { ReactComponent as EditIcon } from "assets/images/square-buttons/edit-line.svg";
import { ReactComponent as ViewIcon } from "assets/images/square-buttons/more.svg";
import { ReactComponent as TrashIcon } from "assets/images/square-buttons/squared-trash.svg";
import Tooltip from "components/Tooltip";
import SortButton from "containers/Members/SortButton";
import { stringToColor } from "helpers/utils";
import { useNavigate } from "react-router-dom";

export const TableHeader = ({ sortingCallback, pageParams }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="left"></TableCell>
        <TableCell align="left">
          <SortButton
            label="Circuit Name"
            value="NAME"
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="left">
          <SortButton
            label="Circuit Description"
            value="DESCRIPTION"
            sortingCallback={sortingCallback}
            pageParams={pageParams}
          />
        </TableCell>
        <TableCell align="right">Actions</TableCell>
      </TableRow>
    </TableHead>
  );
};

export const TableItem = ({ data, index, editCallback, deleteCallback }) => {
  const navigate = useNavigate();

  return (
    <TableRow role="checkbox">
      <TableCell align="left">
        <Stack direction={"row"} alignItems="center">
          <span
            style={{ backgroundColor: stringToColor(data.title) }}
            className={"rounded-circle member-icon"}
          >
            <IconGenericDocIcon width={24} height={24} stroke={"#fff"} />
          </span>
        </Stack>
      </TableCell>
      <TableCell align="left" className="bold black" width="30%">
        {data.title}
      </TableCell>
      <TableCell align="left" className="bold black" width="50%">
        <span className="description-text ellipsis-one-line">{data.description}</span>
      </TableCell>

      <TableCell align="right" width="20%">
        <div className={"buttons-bar"}>
          <Tooltip content={"Delete"} direction="bottom">
            <button onClick={() => deleteCallback(data.id)}>
              <TrashIcon />
            </button>
          </Tooltip>
          <Tooltip content={"Edit"} direction="bottom">
            <button onClick={() => editCallback(data.id)}>
              <EditIcon />
            </button>
          </Tooltip>
          <Tooltip content={"View"} direction="bottom">
            <button onClick={() => navigate(`/workout-templates/circuits/${data.id}`)}>
              <ViewIcon />
            </button>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
};
